import React, { useState } from "react";
import "../../pages/forms/form4.css";
import { useNavigate } from 'react-router-dom';;

const EditForm4 = ({formData,setFormData,setStep}) => {
  console.log(formData)

  const [errors, setErrors] = useState({});
  const navigate = useNavigate(); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "required";
      }
    }); 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const HandleNext = (e) => {
    e.preventDefault(); 
    if (validate()) { 
      navigate(setStep(5));

    }
  };

  const handleBack = () => {
    setStep(3) 
};

  return (
    <>
    <div className="form4-background">
      <div className="form4-section"> 
        <h2 className="form4-title">Living Location Details(4/7)</h2>
        <form>
          <div className="form4-row">
            {/* <div className="form4-group">
              <label>Country<span className='error fs-star'>*</span></label>
              <select name="country" value={formData.country} onChange={handleChange}>
                <option value="">-- Select Country --</option>
                <option value="India">India</option>
              </select>
              {errors.country && <span className="error-text">{errors.country}</span>}
            </div>

            <div className="form4-group">
              <label>State<span className='error fs-star'>*</span></label>
              <select name="state" value={formData.state} onChange={handleChange}>
                <option value="">-- Select State --</option>
                <option value="Tamil Nadu">Tamil Nadu</option>
              </select>
              {errors.state && <span className="error-text">{errors.state}</span>}
            </div> */}

            <div className="form4-group">
              <label>living place<span className='error fs-star'>*</span></label>
              <input
                type="text"
                name="livingPlace"
                placeholder="Enter your district"
                value={formData.livingPlace}
                onChange={handleChange}
              />
              {errors.livingPlace && <span className="error-text">{errors.livingPlace}</span>}
            </div>

            <div className="form4-group">
              <label>Current Living Place<span className='error fs-star'>*</span></label>
              <input
                type="text"
                name="currentlivingplace"
                placeholder="Enter your current living place"
                value={formData.currentlivingplace}
                onChange={handleChange}
              />
              {errors.currentlivingplace && <span className="error-text">{errors.currentlivingplace}</span>}
            </div>
          </div>

          <div className="form4-btn-group">
            <button type="button" className="back-btn-4" onClick={handleBack}>
              Back
            </button>
            <button type="button" className="submit-btn-4" onClick={HandleNext}>
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
};

export default EditForm4;  
